import { render, staticRenderFns } from "./VideoGalleryItem.vue?vue&type=template&id=2d5ad338&scoped=true&"
import script from "./VideoGalleryItem.vue?vue&type=script&lang=js&"
export * from "./VideoGalleryItem.vue?vue&type=script&lang=js&"
import style0 from "./VideoGalleryItem.vue?vue&type=style&index=0&id=2d5ad338&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../voicecasting.sk/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d5ad338",
  null
  
)

export default component.exports